
// fall back
import React from 'react';
import PropTypes from 'prop-types';

const CustomButton = ({ onClick, disabled, children, className }) => {
    return (
        <button
            className={`px-3 md:px-8 py-1 md:py-2 ${disabled ? 'bg-disabled-btn text-disabled' : 'bg-enabled-btn text-white'
                } text-xs lg:text-base font-medium rounded-md ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

CustomButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default CustomButton;
